import { transitQueryKeys } from './declaration/form/transit/keys'
import { consignmentQueryKeys } from './declaration/consignment/keys'
import { transitOperationQueryKeys } from './declaration/transit-operation/keys'
import { guaranteeQueryKeys } from './declaration/guarantee/keys'
import { consignmentDocumentQueryKeys } from './declaration/consignment-document/keys'
import authorisationQueryKeys from './declaration/authorisation/keys'
import { houseConsignmentQueryKeys } from './declaration/house-consignment/keys'
import { houseConsignmentDocumentQueryKeys } from './declaration/house-consignment-document/keys'
import { consignmentItemQueryKeys } from './declaration/consignment-item/keys'
import { consignmentItemDocumentQueryKeys } from './declaration/consignment-item-document/keys'
import { additionalReferenceQueryKeys } from './declaration/additional-reference/keys'
import { eventLogQueryKeys } from './declaration/event-log/keys'
import { transitOperationInfoQueryKeys } from './declaration/preview/transit-operation-info/keys'
import { directoEventQueryKeys } from './declaration/form/directo-event/keys'
import { transitOperationAuditQueryKeys } from './transit-operation-audit/keys'
import { newsQueryKeys } from './news/keys'

// eslint-disable-next-line import/prefer-default-export
export const QueryKeys = {
  additionalReference: additionalReferenceQueryKeys,
  authorisation: authorisationQueryKeys,
  consignment: consignmentQueryKeys,
  consignmentDocument: consignmentDocumentQueryKeys,
  consignmentItem: consignmentItemQueryKeys,
  consignmentItemDocument: consignmentItemDocumentQueryKeys,
  directoEvent: directoEventQueryKeys,
  eventLog: eventLogQueryKeys,
  guarantee: guaranteeQueryKeys,
  houseConsignment: houseConsignmentQueryKeys,
  houseConsignmentDocument: houseConsignmentDocumentQueryKeys,
  news: newsQueryKeys,
  transit: transitQueryKeys,
  transitOperation: transitOperationQueryKeys,
  transitOperationInfo: transitOperationInfoQueryKeys,
  transitOperationAudit: transitOperationAuditQueryKeys,
}
